import { ConfigModel } from '@/domain/models'
import { AccessDeniedError, UnexpectedError, UnexpectedResultFormatError } from '@/domain/errors'
import { HttpClient, HttpRequest, HttpStatusCode } from '@/data/protocols'
import { GetUnitConfig, GetUnitConfigParams } from '@/domain/usecases'

export class RemoteGetUnitConfig implements GetUnitConfig {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<ConfigModel>
  ) { }

  async getAll (params: GetUnitConfigParams): Promise<ConfigModel> {
    const request: HttpRequest = {
      url: `${this.url}/api/portal/configs`,
      method: 'get',
      params
    }

    const { statusCode, body } = await this.httpClient.request(request)

    switch (statusCode) {
      case HttpStatusCode.ok:
        if (!body) {
          throw new UnexpectedResultFormatError()
        }
        return body
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}
